export default "__VITE_ASSET__DKqzK9H5__"